function triggerBlobDownload(blob, fileName) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}

function getFileNameFromDisposition(header) {
  if (!header) {
    return null;
  }

  const utf8Match = /filename\*=UTF-8''([^;\n]+)/i.exec(header);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      return utf8Match[1].trim();
    }
  }

  const quotedMatch = /filename="([^"]+)"/i.exec(header);
  if (quotedMatch?.[1]) {
    return quotedMatch[1];
  }

  const plainMatch = /filename=([^;\n]+)/i.exec(header);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim();
  }

  return null;
}

export function downloadBlob(blob, fileName) {
  triggerBlobDownload(blob, fileName);
}

export function resolveDownloadFileName(header, fallbackName) {
  const fromHeader = getFileNameFromDisposition(header);
  if (fromHeader) {
    return fromHeader;
  }

  return fallbackName.includes('.') ? fallbackName : `${fallbackName}.jpg`;
}
